import { useQuery } from 'react-query';
import CacheKeysEnum from '../../CacheKeysEnum';
import api from '../../Api';

type UseWebReaderGalleyAccessType = {
	isLoading: boolean;
	hasWebReaderGalleyAccess: (sku: string) => boolean;
};

export const useWebReaderGalleyAccess = (): UseWebReaderGalleyAccessType => {
	const { data: skusAvailableInWebReader, isLoading } = useQuery<string[]>(
		CacheKeysEnum.SkusAvailableInWebReader,
		fetchSkusAvailableInWebReader,
	);

	return {
		isLoading,
		hasWebReaderGalleyAccess: (sku: string) => {
			if (isLoading || !skusAvailableInWebReader) return false;
			return skusAvailableInWebReader.includes(sku);
		},
	};
};

async function fetchSkusAvailableInWebReader(): Promise<string[]> {
	try {
		const endpoint = '/api/me/galleys/available/webreader/skus';
		return await api.get(endpoint);
	} catch (err) {
		console.error((err as Error).message);
		return [];
	}
}
